import ReactDOM from "react-dom";
import React from "react";
import { OlympiacosApp } from "../pageComponents/olympiacosPage/olympiacos-page";

ReactDOM.render(<OlympiacosApp />, document.querySelector("#OlympiacosPage"));
